




























































































































































    import {
        defineComponent,
        onMounted,
        onUnmounted,
        onBeforeUnmount,
        ref,
        watch,
        computed
    } from "@vue/composition-api";
    import useMap from "@/utilities/useGoogleMaps";
    import { alarm, app } from "@/store";
    import { profile as profilestore } from "@/store/index";
    import ProfileViewModel from "@/models/ProfileViewModel";
    import moment from "moment-timezone";

    export default defineComponent({
        name: "MapView",
        setup(_, { root }) {
            const map = ref();
            const { googleMapApi } = useMap();
            const location = ref<GeolocationPosition>();
            let myGoogleMap: google.maps.Map;
            let shipMarker: google.maps.Marker;
            let userMarker: google.maps.Marker;
            let geoFence: google.maps.Circle;
            let geoFenceDisarmed: google.maps.Circle;
            let shipIcon: google.maps.Icon;
            let userIcon: google.maps.Icon;
            let user: google.maps.LatLng;
            let ship: google.maps.LatLng;
            let poly: google.maps.Polyline;
            let polyBoat: google.maps.Polyline;
            let infoWindow: google.maps.InfoWindow;
            let infoWindowBoat: google.maps.InfoWindow;
            let timer: any;
            let timerBoat: any;
            let showDialog = ref<boolean>(false);
            let showGeofence = ref<boolean>(true);
            let unsavedGeofenceRadius: number;
            const errorMessage = ref<string>("");

            // === NEW helpers for nice InfoWindows with local time ===
            const userTZ = ref<string>(
                Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
            );
            const formatLocal = (ts: number | string, fmt = "YYYY-MM-DD HH:mm:ss z") =>
                (typeof ts === "number" ? moment(ts) : moment.utc(ts))
                    .tz(userTZ.value)
                    .format(fmt);

            const infoCard = (title: string, rows: Array<[string, string | number]>) => `
  <div style="
    font-family: system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
    color:#fff; background:#0b132b; border-radius:12px;
    min-width:260px; max-width:340px; overflow:hidden;">
    <div style="padding:10px 36px 10px 12px; font-weight:600; font-size:14px;">
      ${title}
    </div>
    <div style="padding:10px 12px; background:rgba(255,255,255,.04)">
      ${rows.map(([k, v]) => `
        <div style="display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid rgba(255,255,255,.08)">
          <div style="opacity:.8">${k}</div>
          <div style="font-weight:600">${v}</div>
        </div>
      `).join("")}
    </div>
  </div>
`;

            const profile = computed<ProfileViewModel>(() => {
                return profilestore.profile;
            });

            const geoFenceRadius = computed<number>(() => {
                return profile.value.geofenceRadius;
            });

            const lat = computed<number>(() => {
                return alarm.lat ? alarm.lat : 0;
            });

            const lng = computed<number>(() => {
                return alarm.lng ? alarm.lng : 0;
            });

            const user_lat = computed<number>(() => {
                return alarm.user_lat ? alarm.user_lat : 0;
            });

            const user_lng = computed<number>(() => {
                return alarm.user_lng ? alarm.user_lng : 0;
            });

            const geofence_lat = computed<number>(() => {
                return profile.value.geofenceLatitude ?? 0;
            });

            const geofence_lon = computed<number>(() => {
                return profile.value.geofenceLongitude ?? 0;
            });

            const latLetter = computed<string>(() => (lat.value >= 0 ? "N" : "S"));

            const lngLetter = computed<string>(() => (lng.value >= 0 ? "E" : "W"));

            const toggle = (isArmed: boolean) => {
                if (!geoFence || !geoFenceDisarmed) return;
                geoFence.setVisible(isArmed); // red circle when armed
                geoFenceDisarmed.setVisible(!isArmed && showGeofence.value); // green circle when disarmed
            };

            const requestUserPosition = () => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position: GeolocationPosition) => {
                            handlePositionSuccess(position);
                        },
                        (error: GeolocationPositionError) => {
                            handlePositionError(error);
                        },
                        { enableHighAccuracy: true, timeout: 4500, maximumAge: 0 }
                    );
                } else {
                    errorMessage.value = "Geolocation is not supported by this browser.";
                    app.error = errorMessage.value;
                }
            };

            const handlePositionSuccess = (position: GeolocationPosition) => {
                alarm.setUserLocation(position);

                location.value = position;

                user = new google.maps.LatLng(
                    position.coords.latitude,
                    position.coords.longitude
                );

                const path = poly.getPath();

                userMarker.setPosition(user);
                userMarker.setVisible(true);

                path.push(user);

                // REPLACED: nice card + local time
                const rowsUser: Array<[string, string | number]> = [
                    ["Local time", formatLocal(position.timestamp)],
                    ["Latitude", userMarker.getPosition().lat().toFixed(6)],
                    ["Longitude", userMarker.getPosition().lng().toFixed(6)]
                ];
                if (Number.isFinite(position.coords.accuracy)) {
                    rowsUser.push(["Accuracy (m)", Math.round(position.coords.accuracy)]);
                }
                const contentUser = infoCard("User position", rowsUser);

                userMarker.addListener("click", () => {
                    infoWindow.close();
                    infoWindow.setContent(contentUser);
                    infoWindow.open(userMarker.getMap(), userMarker);
                });
            };

            const goToGeoPerm = () => {
                root.$router.push({
                    name: "geo-permission",
                    params: { destination: "map" }
                });
            };

            const handlePositionError = (error: GeolocationPositionError) => {
                if (error.code === error.PERMISSION_DENIED) {
                    errorMessage.value = "User denied the request for geolocation.";
                } else if (error.code === error.POSITION_UNAVAILABLE) {
                    errorMessage.value = "Location information is unavailable.";
                } else if (error.code === error.TIMEOUT) {
                    errorMessage.value = "The request to get user location timed out.";
                } else {
                    errorMessage.value = "An unknown error occurred.";
                }
                app.error = errorMessage.value;
                goToGeoPerm();
            };

            const updateShipPosition = () => {
                const pathBoat = polyBoat.getPath();

                if (lat.value != 0 && lng.value != 0) {
                    ship = new google.maps.LatLng(lat.value, lng.value);

                    shipMarker.setPosition(ship);

                    pathBoat.push(ship);

                    // REPLACED: nice card + local time
                    const rowsBoat: Array<[string, string | number]> = [
                        ["Local time", formatLocal(Date.now())],
                        ["Latitude", shipMarker.getPosition().lat().toFixed(6)],
                        ["Longitude", shipMarker.getPosition().lng().toFixed(6)]
                    ];
                    const contentBoat = infoCard("Boat position", rowsBoat);

                    shipMarker.addListener("click", () => {
                        infoWindowBoat.close();
                        infoWindowBoat.setContent(contentBoat);
                        infoWindowBoat.open(shipMarker.getMap(), shipMarker);
                    });

                    // Keep green (disarmed) geofence following ship
                    if (!armed.value && geoFenceDisarmed) {
                        geoFenceDisarmed.setCenter(ship);
                    }

                    if (!alarm.trackingStatus) {
                        updateGeoFenceRadius();
                    }
                }
            };

            const start_tracking = async () => {
                if (!alarm.trackingStatus) {
                    await alarm.catchThiefStart(20); // <� calls Particle via server
                    userMarker.setVisible(true);
                    poly.setVisible(true);
                    timer = setInterval(() => {
                        requestUserPosition();
                    }, 10000);
                    timerBoat = setInterval(() => {
                        alarm.getGeoLocation();
                    }, 10000);
                }
            };

            const stop_tracking = async () => {
                if (alarm.trackingStatus) {
                    await alarm.catchThiefStop(); // <� tells Particle to stop + flips UI off
                    clearInterval(timer);
                    clearInterval(timerBoat);
                    userMarker.setVisible(false);
                    poly.setVisible(false);
                }
            };

            const saveGeofence = async () => {
                await profilestore.Update(profile.value);
                geoFence.setRadius(profile.value.geofenceRadius);
                geoFenceDisarmed.setRadius(profile.value.geofenceRadius);
                unsavedGeofenceRadius = profile.value.geofenceRadius;
                updateGeoFenceRadius();
                showDialog.value = false;
            };

            const showGeofenceDialog = () => {
                profile.value.geofenceRadius = unsavedGeofenceRadius;
                updateGeoFenceRadius();
                showDialog.value = true;
            };

            const closeGeofenceDialog = () => {
                profile.value.geofenceRadius = unsavedGeofenceRadius;
                updateGeoFenceRadius();
                showDialog.value = false;
            };

            /*
             Zoom level 16 = 175 - 250
             Zoom level 17 = 90 - 175
             Zoom level 18 = 45 - 90
             Zoom level 19 = 25 - 45
             */
            const updateGeoFenceRadius = () => {
                if (
                    profile.value.geofenceRadius >= 175 &&
                    profile.value.geofenceRadius <= 250
                ) {
                    myGoogleMap.setZoom(16);
                } else if (
                    profile.value.geofenceRadius >= 90 &&
                    profile.value.geofenceRadius < 175
                ) {
                    myGoogleMap.setZoom(17);
                } else if (
                    profile.value.geofenceRadius >= 45 &&
                    profile.value.geofenceRadius < 90
                ) {
                    myGoogleMap.setZoom(18);
                } else if (
                    profile.value.geofenceRadius >= 25 &&
                    profile.value.geofenceRadius < 45
                ) {
                    myGoogleMap.setZoom(19);
                }

                if (geoFence) {
                    geoFence.setRadius(profile.value.geofenceRadius);
                    myGoogleMap.setCenter(geoFence.getCenter());
                }

                if (geoFenceDisarmed) {
                    geoFenceDisarmed.setRadius(profile.value.geofenceRadius);
                    myGoogleMap.setCenter(geoFenceDisarmed.getCenter());
                }
            };

            const updateGeoFenceVisible = () => {
                if (geoFenceDisarmed) {
                    geoFenceDisarmed.setVisible(showGeofence.value);
                }
            };

            const armed = computed<boolean>(() => {
                return alarm.armed;
            });

            const isLoading = computed<boolean>(() => {
                return alarm.trackingStatus;
            });

            const refreshGeofenceLock = async () => {
                await profilestore.Get(); // fetch latest from DB
                const lock = new google.maps.LatLng(
                    profile.value.geofenceLatitude,
                    profile.value.geofenceLongitude
                );
                if (geoFence) {
                    geoFence.setCenter(lock);
                    geoFence.setVisible(true);
                }
                if (geoFenceDisarmed) geoFenceDisarmed.setVisible(false);
                if (myGoogleMap) myGoogleMap.setCenter(lock);
            };

            onMounted(async () => {
                await alarm.getGeoLocation(); // hydrate lat/lng once on load
                profilestore.Get();
                googleMapApi.load().then(() => {
                    console.log("Google Maps API loaded");
                    const markerPos = new google.maps.LatLng(lat.value, lng.value);
                    const geofencePos = new google.maps.LatLng(
                        geofence_lat.value,
                        geofence_lon.value
                    );
                    const userPos = new google.maps.LatLng(user_lat.value, user_lng.value);
                    infoWindow = new google.maps.InfoWindow();
                    infoWindowBoat = new google.maps.InfoWindow();
                    userMarker = new google.maps.Marker();

                    shipIcon = {
                        url: "https://dsspoc.azurewebsites.net/img/icons/map-marker-device.svg",
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    userIcon = {
                        url: "https://dsspoc.azurewebsites.net/img/icons/map-marker-user.svg",
                        scaledSize: new google.maps.Size(80, 80),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(40, 80)
                    };

                    myGoogleMap = new google.maps.Map(map.value, {
                        center: markerPos,
                        mapTypeId: "satellite",
                        zoom: 16,
                        disableDefaultUI: true,
                        zoomControl: false,
                        backgroundColor: "#000000",
                        mapTypeControl: true,
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
                        },
                        fullscreenControl: true
                    });

                    shipMarker = new google.maps.Marker({
                        position: markerPos,
                        map: myGoogleMap,
                        icon: shipIcon,
                        title: profile.value.shipName
                    });

                    userMarker.setPosition(userPos);
                    userMarker.setMap(myGoogleMap);
                    userMarker.setIcon(userIcon);
                    userMarker.setTitle("You are here.");
                    userMarker.setVisible(false);

                    poly = new google.maps.Polyline({
                        strokeColor: "#FF0000",
                        strokeOpacity: 1.0,
                        strokeWeight: 2,
                        zIndex: 10
                    });
                    poly.setMap(myGoogleMap);

                    polyBoat = new google.maps.Polyline({
                        strokeColor: "#FF0000",
                        strokeOpacity: 1.0,
                        strokeWeight: 2,
                        zIndex: 10
                    });
                    polyBoat.setMap(myGoogleMap);

                    geoFence = new google.maps.Circle({
                        strokeColor: "#FF0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#FF0000",
                        fillOpacity: 0.35,
                        map: myGoogleMap,
                        center: geofencePos,
                        radius: geoFenceRadius.value,
                        zIndex: 10,
                        visible: false
                    });
                    geoFenceDisarmed = new google.maps.Circle({
                        strokeColor: "#00FF00",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#00FF00",
                        fillOpacity: 0.35,
                        map: myGoogleMap,
                        center: markerPos,
                        radius: geoFenceRadius.value,
                        zIndex: 10,
                        visible: showGeofence.value
                    });
                    toggle(alarm.armed);
                    updateShipPosition();
                    unsavedGeofenceRadius = profile.value.geofenceRadius;
                    updateGeoFenceRadius();
                });
            });

            onBeforeUnmount(() => {
                stop_tracking();
            });

            onUnmounted(() => {
                stop_tracking();
            });

            watch(armed, async (isArmed, wasArmed) => {
                if (isArmed && !wasArmed) {
                    await refreshGeofenceLock();
                } else if (!isArmed && wasArmed) {
                    if (geoFence) geoFence.setVisible(false);
                    if (geoFenceDisarmed) geoFenceDisarmed.setVisible(showGeofence.value);
                }
            });

            // keep boat position synced whenever alarm.lat/alarm.lng change
            watch([lat, lng], ([newLat, newLng]) => {
                if (!shipMarker || !polyBoat) return;
                if (!newLat || !newLng) return;

                const pos = new google.maps.LatLng(newLat, newLng);
                shipMarker.setPosition(pos);
                polyBoat.getPath().push(pos);

                // keep disarmed geofence following the boat
                if (!armed.value && geoFenceDisarmed) {
                    geoFenceDisarmed.setCenter(pos);
                }
            });

            // This ensures the UI cleans up even if the auto-stop fired from the store
            watch(isLoading, on => {
                if (!on) {
                    clearInterval(timer);
                    clearInterval(timerBoat);
                    if (userMarker) userMarker.setVisible(false);
                    if (poly) poly.setVisible(false);
                }
            });

            alarm.$watch(module => module.armed, toggle);
            alarm.$watch(module => module.lastKnownLocation, updateShipPosition);
            return {
                armed,
                map,
                geoFence,
                geoFenceDisarmed,
                latLetter,
                lngLetter,
                start_tracking,
                stop_tracking,
                isLoading,
                showGeofenceDialog,
                closeGeofenceDialog,
                profile,
                showDialog,
                saveGeofence,
                updateGeoFenceRadius,
                showGeofence,
                updateGeoFenceVisible,
                updateShipPosition
            };
        },
        created: function () {
            this.$once("hook:beforeDestroy", () => {
                alarm.stopTracking();
            });
        },
        data: () => ({
            fab: false,
            fab2: false,
            hover: false,
            transition: "fade-transition",
            direction: "top",
            showTTs: true,
            showThief: true,
            showSettings: true
        })
    });
